"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runBulkActionSyncFunctionName = exports.cancelBulkActionFunctionName = exports.createBulkActionFunctionName = exports.bulkActionMessageType = void 0;
exports.bulkActionMessageType = 'bulkAction';
exports.createBulkActionFunctionName = 'createBulkAction';
exports.cancelBulkActionFunctionName = 'cancelBulkAction';
exports.runBulkActionSyncFunctionName = 'runBulkActionSync';
